
import Injection = EECore.Injection;
import DocumentService from "../../services/documentCentre/documentService";

@Injection.injectableClass("DocumentCentreFavouriteDocumentBehavior")
export default class FavouriteDocumentBehavior {

  @Injection.injectableProperty("DocumentCentreFavouriteDocumentBehavior", "DocumentCentreDocumentService")
  private documentService: DocumentService;

  constructor(documentService: DocumentService) {
    this.documentService = documentService;
  }

  apply(documentElement: Element): void {
    const documentId = documentElement.getAttribute("data-id");
    const removeFavouriteButton = documentElement.querySelector("[data-action='remove']");
    if (removeFavouriteButton != null) {
      removeFavouriteButton.addEventListener("click", () => {
        this.documentService.removeFavouriteDocument(documentId).then(() => {
          documentElement.parentElement.removeChild(documentElement);
        });
      });
    }

    const moveFavouriteUpButton = documentElement.querySelector("[data-action='move-up']");
    if (moveFavouriteUpButton) {
      moveFavouriteUpButton.addEventListener("click", () => {
        this.documentService.moveFavouriteUp(documentId).then(() => {
          documentElement.parentElement.insertBefore(documentElement, documentElement.previousElementSibling);
        });
      });
    }

    const moveFavouriteDownButton = documentElement.querySelector("[data-action='move-down']");
    if (moveFavouriteDownButton) {
      moveFavouriteDownButton.addEventListener("click", () => {
        this.documentService.moveFavouriteDown(documentId).then(() => {
          documentElement.parentElement.insertBefore(documentElement.nextElementSibling, documentElement);
        });
      });
    }
  }

}